export class CicFeeReasonsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCicFeeReasonsFiltered({ applicationId }) {
    return this.#http.get(`/CicFeeReasons/filtered/${applicationId}`);
  }
}
